<script setup>
import { computed, onMounted } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import useComponentsStore from '@/stores/components';
import { init } from '@/utils/postmonger';
import { RIGHT_PANEL_WIDTH } from '@/config/constant';
import VersionPanel from '@/components/common/VersionPanel.vue';
import canvas from '@/utils/canvas';

const { components } = useComponentsStore();

const route = useRoute();
const query = {};
const search = (window.location.search || '').slice(1);

search.split('&').forEach((str) => {
  const [key, value] = str.split('=');

  query[key] = value;
});

// run  core
if (query?.nonce && query?.organizationId) {
  canvas({ nonce: query.nonce, organizationId: query.organizationId });
  document.querySelector('html').classList.add('mode--core');
  let originOuterWidth = window.outerWidth;
  setInterval(() => {
    const previewOuterWidth = window.outerWidth;
    if (previewOuterWidth !== originOuterWidth) {
      // const calcPreviewOuterWidth = previewOuterWidth * 0.9 - 3 * 16 - 30;
      // const overflowAuto = calcPreviewOuterWidth > 1500 ? 'visible' : 'auto';
      //  document.querySelector('.wrap.no-header').style =
      // `max-width: ${calcPreviewOuterWidth}px; overflow-x:${overflowAuto};`;
      originOuterWidth = previewOuterWidth;
    }
  }, 1000);
} else {
  init();
  document.querySelector('html').classList.add('mode--mc');
}

const layoutComponentName = computed(() => route.meta.layout ?? 'none-layout');

onMounted(() => {
  document.body.style = `--leftSidebarWidth: 130px; --rightPanelWidth: ${RIGHT_PANEL_WIDTH}px;`;
});

</script>
<template>
  <v-app>
    <component :is="layoutComponentName">
      <RouterView />
    </component>
    <component
      v-for="[id, value] in Object.entries(components)"
      :key="`component-${id}`"
      :is="value"
      :id="id"
    />
    <VersionPanel />
  </v-app>
</template>
